module.exports = __webpack_public_path__ + "static/toggl-global-main-151530a38cfe1e38f2a83b9112356e4e.jpg";